import React, { createContext, useState, useContext } from "react";
import { Button, Modal } from "react-bootstrap";

const BranchDefinationContext = createContext();

export const BranchDefinationContextProvider = ({ children }) => {
  const [showBranchDefinationAlert, setShowBranchDefinationAlert] =
    useState(false);

  const branchDefinationAlertOpen = () => setShowBranchDefinationAlert(true);

  const branchDefinationAlertClose = () => setShowBranchDefinationAlert(false);

  return (
    <BranchDefinationContext.Provider
      value={{
        branchDefinationAlertOpen,
      }}
    >
      <Modal
        className="fade"
        show={showBranchDefinationAlert}
        onHide={branchDefinationAlertClose}
        // size="lg"
      >
        <Modal.Header>
          <Modal.Title>
            <i className="fa fa-warning"></i> Branch Defination in-complete
            Alert
          </Modal.Title>
          <Button
            type="button"
            variant=""
            className="btn-close"
            onClick={() => {
              branchDefinationAlertClose();
            }}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <p>
            You can access the application transaction forms after complete the
            Branch Defination.
          </p>
          <p>Please fill all necessary branch defination details.</p>
        </Modal.Body>
      </Modal>
      {children}
    </BranchDefinationContext.Provider>
  );
};

export const useBranchDefinationContext = () => {
  return useContext(BranchDefinationContext);
};
